import {UiState} from "./ui-state";

export class UiService {
	private readonly _eventHandler: EventTarget = new EventTarget();

	private _cartVisible: boolean = false;

	public showCart() {
		if (this._cartVisible !== true) {
			this._cartVisible = true;

			this.raiseOnChanged();
		}
	}

	public hideCart() {
		if (this._cartVisible !== false) {
			this._cartVisible = false;

			this.raiseOnChanged();
		}
	}

	public toState(): UiState {
		return {
			cartVisible: this._cartVisible
		};
	}

	public addEventListener(handler: (() => void)) {
		this._eventHandler.addEventListener('ui-service:on-changed', handler);
	}

	private raiseOnChanged() {
		this._eventHandler.dispatchEvent(new Event('ui-service:on-changed'));
	}
}
